export const MORE_LINES_SIGNAL = 1;
export const FEWER_LINES_SIGNAL = -1;
